(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').directive('myDevice', MyDevice);

  function MyDevice() {
    return {
      restrict: 'E',
      scope: {
        selectedBan: '=',
        selectedCtn: '=',
        hupPermitted: '=',
        lostDeviceStatus: '=',
        voiceMailIndicator: '=',
        initHup: '='
      },
      templateUrl: 'modules/my-account/wireless/my-device/my-device.view.html',
      controller: 'myDeviceController',
      controllerAs: 'mdCtrl',
      bindToController: true
    };
  }

})();
